import { Button } from "@gw/web-basic-components";
import React, { useMemo } from "react";
import type { NotificationProps } from "./dto";
import { ReactComponent as CloseSvg } from "../../assets/close.svg";
import { useHistory } from "react-router-dom";
import cx from "classnames";
import TriggerPng from "../../assets/xiaogu36.png";
import { isFullUrl } from "./utils";

/**
 * 客户满意度
 */
const Notification = (props: NotificationProps) => {
  const {
    style,
    className,
    open,
    triggerStyle,
    triggerVisible = true,
    triggerText = "调查问卷",
    triggerImage = TriggerPng,
    title,
    desc,
    okText = "点击参与",
    bgSrc,
    link,
    placement = "bottomRight",
    onOk,
    onClose,
  } = props;

  console.log(
    "open-r===",
    placement,
    !!open && ["topRight", "bottomRight"].includes(placement)
  );

  const history = useHistory();

  /** 根据placement获取初始位置 */
  const placeStyle = useMemo<React.CSSProperties>(() => {
    const top = "3.75rem";
    const bottom = "3.75rem";
    const left = "-32.5rem";
    const right = "-32.5rem";

    switch (placement) {
      case "bottomRight":
        return { right, bottom };
      case "topRight":
        return { right, top };
      case "bottomLeft":
        return { left, bottom };
      case "topLeft":
        return { left, top };
      default:
        return {};
    }
  }, [placement]);

  /**
   * 内部确认按钮点击回调
   */
  const onInnerOk = () => {
    onOk?.();
    if (link) {
      if (isFullUrl(link)) {
        window.open(link, "_blank");
      } else {
        history.push(link);
      }
    }
  };

  /**
   * 内部关闭按钮点击回调
   */
  const onInnerClose = () => {
    onClose?.();
  };

  return (
    <>
      <div
        style={triggerStyle}
        className={cx("wbuc-notification-trigger", {
          display: triggerVisible,
        })}
      >
        <img
          alt=""
          className="wbuc-notification-trigger-image"
          src={triggerImage}
        />
        <div className="wbuc-notification-trigger-box">
          <span
            onClick={() => onInnerOk()}
            className="wbuc-notification-trigger-text"
          >
            {triggerText}
          </span>
        </div>
      </div>
      <div
        style={{ ...placeStyle, ...style }}
        className={cx("wbuc-notification-modal", {
          "open-r": !!open && ["topRight", "bottomRight"].includes(placement),
          "close-r": !open && ["topRight", "bottomRight"].includes(placement),
          "open-l": !!open && ["topLeft", "bottomLeft"].includes(placement),
          "close-l": !open && ["topLeft", "bottomLeft"].includes(placement),
          "bg-has-img": !!bgSrc,
          className,
        })}
      >
        <div className="wbuc-notification-modal-title">{title}</div>
        <div className="wbuc-notification-modal-desc">{desc}</div>
        <Button
          className="wbuc-notification-modal-ok"
          type="primary"
          onClick={onInnerOk}
        >
          {okText}
        </Button>
        <CloseSvg
          className="wbuc-notification-modal-close"
          style={{ width: "1rem", height: "1rem" }}
          onClick={onInnerClose}
        />
        {bgSrc && (
          <img alt="" src={bgSrc} className="wbuc-notification-modal-bg" />
        )}
      </div>
    </>
  );
};

export default Notification;
